export const CHAT_STAGING_ADDON_KEY = 'staging.halp.com';
export const CHAT_PROD_ADDON_KEY = 'halp.com';
export const GET_CHAT_APP_STATUS_ERROR = 'getChatAppStatusError';
export const INSTALL_CHAT_APP_ERROR = 'installChatAppError';
export const CHAT_APP_ID = 'servicedesk.chat-settings';
export const CHAT_APP_NOT_ENABLED = 'chatAppNotEnabledError';
export const METRICS_PAGE_ID = 'project-settings-apps.service-desk-chat-settings';
